module.exports = __webpack_public_path__ + "img/en-plugin2.25b80921.png";